import { Check } from "lucide-react";

/**
 * The reader's own mark on a problem (`EX-PUB21`): a filled check once solved,
 * a dashed ring once tried, an empty ring before. The library's status column
 * and, since `EX-PLR01`, the Problems set's You column draw this one mark; the
 * caller gives it the words.
 */
export function SolvedMark({
  state,
  label,
}: {
  state: "solved" | "attempted" | "unsolved" | "untried" | null;
  label: string;
}) {
  if (state === "solved") {
    return (
      <span
        role="img"
        aria-label={label}
        className="inline-flex h-[22px] w-[22px] items-center justify-center rounded-full bg-emerald-700 text-white"
      >
        <Check className="h-[13px] w-[13px]" strokeWidth={3} aria-hidden />
      </span>
    );
  }
  if (state === "attempted") {
    return (
      <span
        role="img"
        aria-label={label}
        className="inline-block h-[22px] w-[22px] rounded-full border-2 border-dashed border-amber-500"
      />
    );
  }
  return <span role="img" aria-label={label} className="inline-block h-[22px] w-[22px] rounded-full border-2 border-neutral-200" />;
}
